/**
 * @generated SignedSource<<bd53d8809c451ac34027a115e29de10e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useCustomizationOptions_item$data = {
  readonly attributes: {
    readonly customizable: ReadonlyArray<{
      readonly option: {
        readonly serviceId: string | null;
      } | null;
      readonly text: string | null;
    } | null> | null;
    readonly ringResizable: ReadonlyArray<{
      readonly option: {
        readonly serviceId: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "useCustomizationOptions_item";
};
export type useCustomizationOptions_item$key = {
  readonly " $data"?: useCustomizationOptions_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCustomizationOptions_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCustomizationOptions_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "customizable",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "ringResizable",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "3dc6b5c939318f1dcf68ad59e0d7a9d3";

export default node;
